import { useState } from 'react';
import { singletonHook } from 'react-singleton-hook';

let globalSetTrialHasStarted = () => { throw new Error('you must useTrialHasStarted before setting its state'); };

export const useTrialHasStarted = singletonHook(undefined, () => {
  const [trialHasStarted, setTrialHasStarted] = useState(false);
  globalSetTrialHasStarted = setTrialHasStarted;
  return trialHasStarted;
});

export const setTrialHasStarted = (mode) => globalSetTrialHasStarted(mode);
